export default __webpack_public_path__ + "static/media/Tatiana_Tobar.23eaa248.png";